export default __webpack_public_path__ + "static/phone-mock-942bde7ebb42b87be0cb34c274b8d457.png";